/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Payment_SubInputs */

const en_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discreet and fast`)
};

const th_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รวดเร็วและเป็นส่วนตัว`)
};

const ja_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迅速かつ匿名`)
};

const fr_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discret et rapide`)
};

const es_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discreto y rápido`)
};

const ru_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстро и конфиденциально`)
};

const zh_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私、快捷`)
};

const vi_safe_payment_sub = /** @type {(inputs: Safe_Payment_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kín đáo và nhanh chóng`)
};

/**
* | output |
* | --- |
* | "Discreet and fast" |
*
* @param {Safe_Payment_SubInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const safe_payment_sub = /** @type {((inputs?: Safe_Payment_SubInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Payment_SubInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_safe_payment_sub(inputs)
	if (locale === "ja") return ja_safe_payment_sub(inputs)
	if (locale === "fr") return fr_safe_payment_sub(inputs)
	if (locale === "es") return es_safe_payment_sub(inputs)
	if (locale === "ru") return ru_safe_payment_sub(inputs)
	if (locale === "zh") return zh_safe_payment_sub(inputs)
	if (locale === "vi") return vi_safe_payment_sub(inputs)
	return en_safe_payment_sub(inputs)
});